import { Box, Typography, Button } from '@mui/material';

import { ModalHelp } from '@modals/ModalNeedHelp/ModalHelp';
//import { CarListData } from '@models/store/carListStore';

import { createTheme, ThemeProvider } from '@mui/material/styles';


interface Props {
  //carList: CarListData[];
  //data: CarListData[];
  show: (component: React.ElementType, props: Object) => void;
  hide: () => void;
}

// Augment the palette to include an ochre color
declare module '@mui/material/styles' {
  interface Palette {
    ochre: Palette['primary'];
  }

  interface PaletteOptions {
    ochre?: PaletteOptions['primary'];
  }
}

// Update the Button's color options to include an ochre option
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    ochre: true;
  }
}
const theme = createTheme({
  palette: {
    ochre: {
      main: '#05297a',
      /*light: '#05297a',
      dark: '#05297a',
      contrastText: '#242105',*/
    },
  },
});

const FoundSearchText = ({ /*carList, data */ show, hide }: Props) => (
  <Box
    display={'flex'}
    flexDirection={'row'}
    justifyContent={'flex-end'}
    alignItems={'center'}
  >
    {/*<Typography fontSize={14}>{data.length} resultados</Typography>*/}
    <ThemeProvider theme={theme}>
      <Button
        onClick={() => show(ModalHelp, { onClose: hide })}
        variant={'text'}
        color={'ochre'}
        //disabled={carList[0].description !== '' ? false : true}
        style={{
          padding: 0,
          /* width: '100%',*/
          fontSize: 14,
          fontWeight: 400,
          textTransform: 'none',
          textDecoration: 'underline',
        }}
      >
        {'No encuentro mi vehículo'}
      </Button>
    </ThemeProvider>
  </Box>
);

export default FoundSearchText;
